// SaniZone 360° viewer — drag-based frame cycling
// Usage:
//   <div class="sh-360" data-frames='["/images/p-360/frame-01.jpg","...",..."/images/p-360/frame-24.jpg"]' data-loading="lazy"></div>
// Frames kunnen 12, 24 of 36 zijn (meer = vloeiender)
(function() {
  'use strict';
  if (typeof window === 'undefined') return;

  function initViewer(el) {
    let frames;
    try { frames = JSON.parse(el.dataset.frames || '[]'); } catch { frames = []; }
    if (!frames.length) return;

    el.classList.add('sh-360-ready');
    el.style.position = 'relative';
    el.style.touchAction = 'pan-y';
    el.style.userSelect = 'none';
    el.style.cursor = 'grab';
    el.innerHTML = `
      <img src="${frames[0]}" alt="" class="sh-360-img" style="width:100%;height:100%;object-fit:contain;pointer-events:none;"/>
      <div class="sh-360-hint" style="position:absolute;bottom:12px;left:50%;transform:translateX(-50%);background:rgba(0,0,0,0.5);color:#fff;padding:6px 12px;border-radius:999px;font-size:11px;letter-spacing:0.1em;text-transform:uppercase;pointer-events:none;opacity:1;transition:opacity 500ms ease;">Sleep om te roteren</div>
      <div class="sh-360-progress" style="position:absolute;bottom:0;left:0;height:2px;background:var(--moss,#4a5c3d);width:0%;transition:width 120ms ease;"></div>
    `;
    const img = el.querySelector('.sh-360-img');
    const hint = el.querySelector('.sh-360-hint');
    const progress = el.querySelector('.sh-360-progress');

    let idx = 0;
    let dragging = false;
    let startX = 0;
    let startIdx = 0;
    let width = el.clientWidth;

    // Preload frames progressief (first 6 direct, rest na load)
    for (let i = 1; i < Math.min(6, frames.length); i++) {
      const im = new Image(); im.src = frames[i];
    }
    window.addEventListener('load', () => {
      for (let i = 6; i < frames.length; i++) {
        const im = new Image(); im.src = frames[i];
      }
    }, { once: true });

    function update() {
      img.src = frames[idx];
      if (progress) progress.style.width = `${(idx / (frames.length - 1)) * 100}%`;
    }

    function onPointerDown(e) {
      dragging = true;
      startX = e.clientX || (e.touches && e.touches[0].clientX);
      startIdx = idx;
      el.style.cursor = 'grabbing';
      hint.style.opacity = '0';
      el.setPointerCapture?.(e.pointerId);
    }
    function onPointerMove(e) {
      if (!dragging) return;
      const x = e.clientX || (e.touches && e.touches[0].clientX);
      width = el.clientWidth;
      const delta = (x - startX) / width;
      const step = Math.round(delta * frames.length * 1.2);
      let next = (startIdx - step) % frames.length;
      if (next < 0) next += frames.length;
      if (next !== idx) { idx = next; update(); }
    }
    function onPointerUp(e) {
      if (!dragging) return;
      dragging = false;
      el.style.cursor = 'grab';
      el.releasePointerCapture?.(e.pointerId);
    }

    el.addEventListener('pointerdown', onPointerDown);
    el.addEventListener('pointermove', onPointerMove);
    el.addEventListener('pointerup', onPointerUp);
    el.addEventListener('pointercancel', onPointerUp);
    el.addEventListener('pointerleave', onPointerUp);

    // Auto-rotate at page-idle (10s na laden) — skip op reduced motion
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      setTimeout(() => {
        let count = 0;
        const auto = setInterval(() => {
          if (dragging) { clearInterval(auto); return; }
          idx = (idx + 1) % frames.length;
          update();
          count++;
          if (count >= frames.length) clearInterval(auto);
        }, 90);
      }, 10000);
    }
  }

  function autoInit() {
    document.querySelectorAll('.sh-360:not(.sh-360-ready)').forEach(el => {
      const lazy = el.dataset.loading === 'lazy';
      if (lazy && 'IntersectionObserver' in window) {
        const io = new IntersectionObserver((entries, obs) => {
          entries.forEach(ent => {
            if (ent.isIntersecting) { initViewer(el); obs.unobserve(el); }
          });
        }, { rootMargin: '200px' });
        io.observe(el);
      } else {
        initViewer(el);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', autoInit);
  } else {
    autoInit();
  }
  window.SH360 = { init: initViewer, autoInit };
})();
